import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import { ReactNode } from "react";
import { Edit } from "@mui/icons-material";

interface EditButtonProps {
    loading: boolean;
    disabled?: boolean;
    variant?: "text" | "outlined" | "contained";
    onClick: () => void;
    label?: ReactNode
}

export const EditButton: React.FC<EditButtonProps> = ({ loading, disabled = false, variant = "contained", onClick, label }) => {
    return (
        <LoadingButton
            loading={loading}
            disabled={disabled}
            size="small"
            color="primary"
            variant={variant}
            startIcon={<Edit />}
            onClick={onClick}
        >
            {label ? label : <Localized id="edit">_Edytuj</Localized>}
        </LoadingButton>
    );
};
